class CrudService {

  constructor ($http, $q) {
    this.$http = $http;
    this.$q = $q;
  }

  getAll(uri, page, sort){
    var deferred = this.$q.defer();

    this.$http.get(uri, {params: {page: page, sort: sort}}).then(
      function(response){
        if (response.status === 200){
          deferred.resolve(response.data);
        } else {
          deferred.reject();
        }
      },
      function (){
        deferred.reject();
      });

    return deferred.promise;
  }

  remove(uri) {
    return this.$http.delete(uri);
  }

  save(item, uri){
    if (item._links){
      // update item
      return this.$http.put(item._links.self.href, item);
    } else {
      // save new item
      return this.$http.post(uri, item);
    }
  }
}

CrudService.$inject = ['$http', '$q'];
export default CrudService;



// WEBPACK FOOTER //
// ./src/main/webapp-files/modules/app/services/crudservice.js